import { AsyncThunk, AsyncThunkPayloadCreator, createAsyncThunk, Draft } from '@reduxjs/toolkit';
import { OptionsObject } from 'notistack';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import store, { createRootReducer } from '../store';
import { IAuthState } from '../store/auth/reducer';
import { IGeneralState } from '../store/general/reducer';

// eslint-disable-next-line no-unused-vars
export type DispatchCall<P> = (payload : P) => void;
export type DispatchCallEmpty = () => void;

export interface INotification {
    message : string | React.ReactNode;
    options ?: Draft<OptionsObject>;
}

export interface ISnackbarNotification extends INotification {
    key : number;
}

export type RootState = ReturnType<typeof createRootReducer>;

export interface IRootState {
    auth : IAuthState;
    general : IGeneralState;
}

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

export type payloadCreator<Returned, ThunkArg> = AsyncThunkPayloadCreator<Returned, ThunkArg, ThunkConfig>;
export declare function AppAsyncThunk<Returned = void, ThunkArg = void>(typePrefix : string, payloadCreator : payloadCreator<Returned, ThunkArg>) : AsyncThunk<Returned, ThunkArg, ThunkConfig>;
export const createAppAsyncThunk : typeof AppAsyncThunk = (typePrefix : string, payloadCreator) => createAsyncThunk(typePrefix, payloadCreator);

export const useAppSelector : TypedUseSelectorHook<RootState> = useSelector;

interface ThunkConfig {
    state : RootState;
}

export type ThunkApi = {
    dispatch : AppDispatch;
    state : RootState;
}
